import styled from 'styled-components';

export const ChartChild = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const SelectedAssetSection = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  padding: 2.4rem 0;
`;
export const Image = styled.img`
  width: 2.4rem;
`;

export const TopSection = styled.div`
  display: flex;
  padding-bottom: 1rem;
  align-items: center;
  gap: 0.8rem;
`;

export const MidSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
  width: 100%;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.borders.default};

  align-items: center;
  justify-content: center;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 2.4rem 0;
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
`;
